<div
  class="tenant-config-page"
  [class.tenant-config-page--standalone]="standalonePage"
  [class.tenant-config-page--embedded]="!standalonePage"
  [testId]="'tenant-config-container'"
>
  <div class="page-container">
    <div class="page-shell">
      <div class="page-toolbar" [testId]="'tenant-config-page-header'">
        <div class="page-heading">
          <h3 class="page-title" [testId]="'tenant-config-page-title'">{{ 'tenant.detail.tenant-config' | i18n }}</h3>
          <p class="page-subtitle" [testId]="'tenant-config-page-subtitle'">{{ lineSectionDescription }}</p>
        </div>
        <div class="page-actions">
          <button
            nz-button
            nzType="default"
            [nzLoading]="pageSpinning"
            (click)="refreshTenantConfig()"
            [testId]="'tenant-config-refresh-button'"
          >
            <i nz-icon nzType="reload" nzTheme="outline"></i>
            <span>{{ 'common.refresh' | i18n }}</span>
          </button>
        </div>
      </div>

      <div class="form-container">
        <nz-spin [nzSpinning]="pageSpinning" [testId]="'tenant-config-spin'">
          <div class="config-scroll">
            <section
              class="inactivity-config-section"
              *ngIf="shouldShowInactivityConfig"
              [testId]="'tenant-config-inactivity-section'"
            >
              <nz-card class="inactivity-config-card" [testId]="'tenant-config-inactivity-card'">
                <div class="inactivity-config-card__header">
                  <div class="inactivity-config-card__meta">
                    <div class="inactivity-icon" [testId]="'tenant-config-inactivity-icon'">
                      <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                    </div>
                    <div class="inactivity-config-card__title-block">
                      <div class="inactivity-config-card__title-row">
                        <h4 class="inactivity-config-card__title" [testId]="'tenant-config-inactivity-title'">
                          <span>{{ 'tenant.detail.inactivity-title' | i18n }}</span>
                        </h4>
                        <span class="status-tag" [ngClass]="inactivityStatusClass" [testId]="'tenant-config-inactivity-status-tag'">
                          <i nz-icon [nzType]="inactivitySavedEnabled ? 'check-circle' : 'minus-circle'" nzTheme="fill"></i>
                          {{ inactivityStatusText }}
                        </span>
                        <span class="status-tag status-tag--unsaved" *ngIf="isInactivityFormChanged" [testId]="'tenant-config-inactivity-unsaved-tag'">
                          <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
                          {{ 'tenant.detail.inactivity-unsaved-badge' | i18n }}
                        </span>
                      </div>
                      <p class="inactivity-config-card__description" [testId]="'tenant-config-inactivity-description'">
                        {{ 'tenant.detail.inactivity-description' | i18n }}
                      </p>
                    </div>
                  </div>

                  <div class="inactivity-config-card__actions" [testId]="'tenant-config-inactivity-actions'">
                    <span class="inactivity-unsaved-hint" *ngIf="isInactivityFormChanged" [testId]="'tenant-config-inactivity-unsaved-hint'">
                      <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                      {{ 'tenant.detail.inactivity-unsaved-hint' | i18n }}
                    </span>
                    <button
                      nz-button
                      nzType="primary"
                      (click)="saveInactivityConfig()"
                      [nzLoading]="inactivitySaving"
                      [disabled]="!isTenantAudited || inactivityForm.invalid || !isInactivityFormChanged"
                      [testId]="'tenant-config-inactivity-save-btn'"
                    >
                      <i nz-icon nzType="save" nzTheme="outline"></i>
                      {{ 'tenant.detail.inactivity-save-action' | i18n }}
                    </button>
                  </div>
                </div>

                <div class="inactivity-config-card__warning" *ngIf="!isTenantAudited" [testId]="'tenant-config-inactivity-warning'">
                  <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
                  <span>{{ 'tenant.detail.inactivity-uncertified-warning' | i18n }}</span>
                </div>

                <div class="inactivity-config-card__content" [testId]="'tenant-config-inactivity-content'">
                  <form nz-form [formGroup]="inactivityForm" nzLayout="vertical" [testId]="'tenant-config-inactivity-form'">
                    <div class="inactivity-form-grid">
                      <nz-form-item class="inactivity-form-item">
                        <nz-form-label [nzNoColon]="true" [testId]="'tenant-config-inactivity-switch-label'">
                          {{ 'tenant.detail.inactivity-switch-label' | i18n }}
                        </nz-form-label>
                        <nz-form-control [nzExtra]="'tenant.detail.inactivity-switch-hint' | i18n">
                          <nz-switch
                            formControlName="enabled"
                            [nzDisabled]="!isTenantAudited"
                            [testId]="'tenant-config-inactivity-switch'"
                          />
                        </nz-form-control>
                      </nz-form-item>

                      <nz-form-item class="inactivity-form-item">
                        <nz-form-label nzRequired [nzNoColon]="true" [testId]="'tenant-config-inactivity-threshold-label'">
                          {{ 'tenant.detail.inactivity-threshold-label' | i18n }}
                        </nz-form-label>
                        <nz-form-control
                          [nzErrorTip]="'tenant.detail.inactivity-threshold-error' | i18n"
                          [nzExtra]="'tenant.detail.inactivity-threshold-hint' | i18n"
                        >
                          <nz-input-number
                            formControlName="inactiveDays"
                            [nzMin]="7"
                            [nzMax]="365"
                            [nzStep]="1"
                            [nzPrecision]="0"
                            [nzDisabled]="!isTenantAudited"
                            [testId]="'tenant-config-inactivity-days-input'"
                          />
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                  </form>
                </div>
              </nz-card>
            </section>

            <section class="line-login-section" [testId]="'tenant-config-line-section'">
              <nz-card class="line-login-card" [testId]="'tenant-config-line-card'">
                <div class="line-login-card__header">
                  <div class="line-login-card__meta">
                    <img src="assets/images/channels/icon-im-line.svg" alt="Line" class="line-icon" [testId]="'tenant-config-line-icon'" />
                    <div class="line-login-card__title-block">
                      <div class="line-login-card__title-row">
                        <h4 class="line-login-card__title" [testId]="'tenant-config-line-card-title'">
                          <span>Line Login Channel</span>
                        </h4>
                        <span class="status-tag" [ngClass]="lineStatusClass" [testId]="'tenant-config-line-status-tag'">
                          <i
                            nz-icon
                            [nzType]="lineStatusClass === 'is-danger' ? 'close-circle' : 'check-circle'"
                            nzTheme="fill"
                            *ngIf="hasLineLoginBindingData"
                          ></i>
                          {{ lineStatusText }}
                        </span>
                      </div>
                      <p class="line-login-card__description" [testId]="'tenant-config-line-card-description'">{{ lineCardDescription }}</p>
                    </div>
                  </div>

                  <div class="line-login-card__actions" [testId]="'tenant-config-line-actions'">
                    <button
                      *ngIf="!hasLineLoginBindingData"
                      nz-button
                      nzType="primary"
                      (click)="showLineBindModal()"
                      [disabled]="!officialServiceNumberId"
                      [testId]="'tenant-config-line-bind-btn'"
                    >
                      <i nz-icon nzType="link"></i>
                      {{ 'tenant.detail.line-login-bind-action' | i18n }}
                    </button>
                    <button
                      *ngIf="hasLineLoginBindingData"
                      nz-button
                      nzType="default"
                      nzDanger
                      (click)="unbindLineLogin()"
                      [nzLoading]="unbindLoading"
                      [testId]="'tenant-config-line-unbind-btn'"
                    >
                      {{ 'tenant.detail.line-login-unbind-action' | i18n }}
                    </button>
                  </div>
                </div>

                <div class="line-login-card__error" *ngIf="lineLoginFailureReason" [testId]="'tenant-config-line-error-reason'">
                  <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
                  <span>{{ lineLoginFailureReason }}</span>
                </div>

                <div class="line-login-card__content" *ngIf="hasLineLoginBindingData" [testId]="'tenant-config-line-bound-content'">
                  <div class="config-info-panel">
                    <h5 class="config-info-panel__title" [testId]="'tenant-config-line-info-title'">
                      <span class="config-info-panel__title-kicker"><i nz-icon nzType="profile" nzTheme="outline"></i></span>
                      <span>{{ 'tenant.detail.line-login-binding-info-title' | i18n }}</span>
                    </h5>

                    <div class="readonly-field" [testId]="'tenant-config-field-channel-id'">
                      <div class="readonly-field__label-row">
                        <label>Channel ID</label>
                        <button
                          nz-button
                          nzType="link"
                          class="readonly-field__copy"
                          (click)="copyValue(lineLoginInfo?.channelId)"
                          [testId]="'tenant-config-copy-channel-id'"
                        >
                          <i nz-icon nzType="copy"></i> {{ 'tenant.detail.copy' | i18n }}
                        </button>
                      </div>
                      <div class="readonly-field__value">{{ lineLoginInfo?.channelId }}</div>
                    </div>

                    <div class="readonly-field" [testId]="'tenant-config-field-channel-secret'">
                      <div class="readonly-field__label-row">
                        <label>Channel Secret</label>
                        <button
                          nz-button
                          nzType="link"
                          class="readonly-field__copy"
                          (click)="copyValue(lineLoginInfo?.channelSecret)"
                          [testId]="'tenant-config-copy-channel-secret'"
                        >
                          <i nz-icon nzType="copy"></i> {{ 'tenant.detail.copy' | i18n }}
                        </button>
                      </div>
                      <div class="readonly-field__value">{{ lineLoginInfo?.channelSecret }}</div>
                    </div>

                    <div class="readonly-field" [testId]="'tenant-config-field-provider-id'">
                      <div class="readonly-field__label-row">
                        <label>Provider ID</label>
                        <button
                          nz-button
                          nzType="link"
                          class="readonly-field__copy"
                          (click)="copyValue(lineLoginInfo?.providerId)"
                          [testId]="'tenant-config-copy-provider-id'"
                        >
                          <i nz-icon nzType="copy"></i> {{ 'tenant.detail.copy' | i18n }}
                        </button>
                      </div>
                      <div class="readonly-field__value">{{ lineLoginInfo?.providerId }}</div>
                    </div>

                    <div class="readonly-field" *ngIf="lineLoginInfo?.liffId" [testId]="'tenant-config-field-liff-id'">
                      <div class="readonly-field__label-row">
                        <label>{{ 'tenant.detail.channel-liff-id' | i18n }}</label>
                        <button
                          nz-button
                          nzType="link"
                          class="readonly-field__copy"
                          (click)="copyValue(lineLoginInfo?.liffId)"
                          [testId]="'tenant-config-copy-liff-id'"
                        >
                          <i nz-icon nzType="copy"></i> {{ 'tenant.detail.copy' | i18n }}
                        </button>
                      </div>
                      <div class="readonly-field__value">{{ lineLoginInfo?.liffId }}</div>
                      <p class="readonly-field__hint">{{ 'tenant.detail.line-login-liff-auto-created-hint' | i18n }}</p>
                    </div>
                  </div>
                </div>

                <div class="line-login-card__guide" [testId]="'tenant-config-line-guide'">
                  <div class="guide-card">
                    <div class="guide-card__header">
                      <span class="section-kicker section-kicker--guide"><i nz-icon nzType="info-circle" nzTheme="outline"></i></span>
                      <span>{{ 'tenant.detail.line-login-guide-title' | i18n }}</span>
                    </div>
                    <div class="guide-card__body">
                      <p class="guide-intro">{{ 'tenant.detail.line-login-guide-intro' | i18n }}</p>
                      <div class="guide-item">
                        <span class="guide-index">1</span>
                        <div>
                          <h5>{{ 'tenant.detail.line-login-guide-item1-title' | i18n }}</h5>
                          <p>{{ 'tenant.detail.line-login-guide-item1-content' | i18n }}</p>
                        </div>
                      </div>
                      <div class="guide-item">
                        <span class="guide-index">2</span>
                        <div>
                          <h5>{{ 'tenant.detail.line-login-guide-item2-title' | i18n }}</h5>
                          <p>{{ 'tenant.detail.line-login-guide-item2-content' | i18n }}</p>
                        </div>
                      </div>
                      <div class="guide-footer">
                        {{ 'tenant.detail.line-login-guide-footer-prefix' | i18n }}
                        <a
                          class="guide-link"
                          href="https://developers.line.biz"
                          target="_blank"
                          rel="noopener noreferrer"
                          [testId]="'tenant-config-line-developers-link'"
                        >
                          {{ 'tenant.detail.line-login-guide-link' | i18n }}
                        </a>
                        {{ 'tenant.detail.line-login-guide-footer-suffix' | i18n }}
                      </div>
                    </div>
                  </div>
                </div>
              </nz-card>
            </section>
          </div>
        </nz-spin>
      </div>
    </div>
  </div>

  <nz-modal
    [(nzVisible)]="lineModalVisible"
    [nzTitle]="'tenant.detail.line-login-bind-modal-title' | i18n"
    [nzOkText]="'tenant.detail.confirm' | i18n"
    [nzCancelText]="'tenant.detail.cancel' | i18n"
    [nzWidth]="600"
    [nzClassName]="'line-bind-modal'"
    [nzOkLoading]="configSaving"
    (nzOnCancel)="handleLineCancel()"
    (nzOnOk)="bindLineLogin()"
    [testId]="'tenant-config-line-modal'"
  >
    <ng-container *nzModalContent>
      <form nz-form [formGroup]="lineForm" class="line-bind-form" [testId]="'tenant-config-line-form'">
        <div class="line-bind-intro" [testId]="'tenant-config-line-intro'">
          {{ 'tenant.detail.line-login-bind-modal-intro' | i18n }}
        </div>
        <div class="line-bind-readme" [testId]="'tenant-config-line-bind-readme'">
          <div class="line-bind-readme__title">
            <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
            {{ 'tenant.detail.line-login-bind-readme-title' | i18n }}
          </div>
          <p>{{ 'tenant.detail.line-login-bind-readme-content' | i18n }}</p>
          <ul>
            <li>{{ 'tenant.detail.line-login-bind-readme-item1' | i18n }}</li>
            <li>{{ 'tenant.detail.line-login-bind-readme-item2' | i18n }}</li>
            <li>{{ 'tenant.detail.line-login-bind-readme-item3' | i18n }}</li>
            <li>{{ 'tenant.detail.line-login-bind-readme-item4' | i18n }}</li>
          </ul>
        </div>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" [nzRequired]="true">Channel ID</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'tenant.detail.line-login-error-channel-id' | i18n">
            <input
              nz-input
              formControlName="channelId"
              [placeholder]="'tenant.detail.line-login-placeholder-channel-id' | i18n"
              [testId]="'tenant-config-line-input-channel-id'"
            />
            <div class="line-bind-hint">{{ 'tenant.detail.line-login-hint-basic-settings' | i18n }}</div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" [nzRequired]="true">Channel Secret</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'tenant.detail.line-login-error-channel-secret' | i18n">
            <input
              nz-input
              formControlName="channelSecret"
              [placeholder]="'tenant.detail.line-login-placeholder-channel-secret' | i18n"
              [testId]="'tenant-config-line-input-channel-secret'"
            />
            <div class="line-bind-hint">{{ 'tenant.detail.line-login-hint-basic-settings' | i18n }}</div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" [nzRequired]="true">Provider ID</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'tenant.detail.line-login-error-provider-id' | i18n">
            <input
              nz-input
              formControlName="providerId"
              [placeholder]="'tenant.detail.line-login-placeholder-provider-id' | i18n"
              [testId]="'tenant-config-line-input-provider-id'"
            />
            <div class="line-bind-hint">{{ 'tenant.detail.line-login-hint-provider-id-match' | i18n }}</div>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>
</div>
